import { MessageSquare } from 'lucide-react'

export default function EmptyConversationPanel() {
  return (
    <div className="flex-1 flex items-center justify-center bg-muted">
      <div className="text-center">
        <MessageSquare className="h-12 w-12 text-muted-foreground mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">Selecione uma sessao para visualizar</p>
      </div>
    </div>
  )
}
